import React from 'react';
import cx from 'classnames';
import Link from 'components/Link';
import type { LinkProps } from 'react-router-dom';

import './TitleLink.scss';

type TitleProps = {
  className?: string;
  title?: string;
};

type TitleLinkProps = TitleProps & LinkProps;

type TitleButtonProps = TitleProps & {
  onClick: () => void;
};

type Props = TitleProps | TitleLinkProps | TitleButtonProps;

function isLink(props: Props): props is TitleLinkProps {
  return 'to' in props;
}

function isButton(props: Props): props is TitleButtonProps {
  return 'onClick' in props;
}

const TitleLink = (props: Props) => {
  if (isLink(props)) {
    const { className, title, ...rest } = props;

    return (
      <Link
        className={cx('title-link', className, {
          'font-italic': !title,
        })}
        {...rest}
      >
        {title || 'No Title'}
      </Link>
    );
  }

  if (isButton(props)) {
    const { className, title, ...rest } = props;

    return (
      <button
        className={cx('title-link', className, {
          'font-italic': !title,
        })}
        type="button"
        {...rest}
      >
        {title || 'No Title'}
      </button>
    );
  }

  const { className, title, ...rest } = props;

  return (
    <span
      className={cx('title-link', className, {
        'font-italic': !title,
      })}
      {...rest}
    >
      {title || 'No Title'}
    </span>
  );
};

export default TitleLink;
